import styled from 'styled-components';

const HistoryRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 16px 0;
  flex-direction: row;

  &:first-of-type {
    margin-top: 0;
  }

  @media (max-width: 414px) {
    flex-direction: column;
  }
`;

const HistoryRowLong = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 365px;
  margin: 16px 0;
  padding: 0 8px;

  &:last-of-type {
    margin: 16px 0 22px;
  }

  > div {
    margin: 0;
  }

  @media (max-width: 414px) {
    flex-direction: column;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    max-width: 100%;
    width: 100%;
  }

  @media (min-width: 768px) {
    padding: 0 30px;
  }
`;

const PaymentInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const commonSubHeaderStyles = styled.h2`
  ${(props) => props.theme.font.heading.v100};
  line-height: 24px;
  color: ${(props) => props.theme.color.primary.v600};
  font-weight: 700;
  margin: 0;
`;

const PaymentType = styled(commonSubHeaderStyles)`
  margin: 0;
`;

const PaymentTypeRed = styled.h2`
  ${(props) => props.theme.font.heading.v100};
  line-height: 24px;
  margin: 0;
  font-weight: 700;
  color: #e03131; // red-2  https://showroom.cvnacorp.com/carvana-css-theme
`;

const PaymentTypeRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const PaymentAmount = styled(commonSubHeaderStyles)`
  margin: 8px 0 0;

  @media (min-width: 414px) {
    margin: 0;
  }
`;

const PaymentAmountRed = styled.h2`
  ${(props) => props.theme.font.heading.v100};
  line-height: 24px;
  font-weight: 700;
  color: #e03131; // red-2  https://showroom.cvnacorp.com/carvana-css-theme
  text-transform: uppercase;
  margin: 8px 0 0;

  @media (min-width: 414px) {
    margin: 0;
  }
`;

const PaymentDate = styled.div`
  ${(props) => props.theme.font.body.v100};
  color: ${(props) => props.theme.color.neutral.v500};
`;

const PaymentPending = styled.div`
  ${(props) => props.theme.font.heading.v100};
  padding: 0 15px;
  margin: 0 0 0 15px;
  border-radius: 12px;
  background-color: #feb948; // yellow-2 https://showroom.cvnacorp.com/carvana-css-theme
  border: none;
  line-height: 24px;
  font-weight: 700;
  font-size: 18px;
`;

const HR = styled.hr`
  border-bottom-color: transparent;
  margin: auto 0;
  height: 1px;
  display: block;
  border: 0;
  border-top: 1px solid #d9dde9;

  &:last-child {
    display: none;
  }

  @media (min-width: 768px) {
    margin: auto 14px;
  }
`;

const HR2 = styled.hr`
  border: none;
  border-top: 1px solid #d9dde9;
  border-bottom-color: transparent;
  height: 1px;
  width: 100%;
  margin: 0;

  &:last-of-type {
    display: none;
  }
`;

export {
  HistoryRow,
  HistoryRowLong,
  PaymentInfo,
  PaymentType,
  PaymentTypeRed,
  PaymentTypeRow,
  PaymentDate,
  PaymentAmount,
  PaymentAmountRed,
  PaymentPending,
  HR,
  HR2,
};
